import React, { useEffect, useState } from "react";
import {
  getDepartments,
  getdutywithdate,
  getEmployee,
  getShift,
  InsertDuty,
} from "../../services/dataService";
import toast from "react-hot-toast";
import Breadcrumb from "../../components/common/Breadcrumb";
import { useLocation, useNavigate } from "react-router-dom";
import { getSecureItem, setSecureItem } from "../../services/SecureStorage";

function DutyAllocationMuster() {
  // Get initial values
  const UID = getSecureItem("userId");
  const isAdmin = getSecureItem("IsAdmin");
  const departmentIds = getSecureItem("DepartmentId") || "";
  const DepId = departmentIds.split(",")[0] || null;
  const { state } = useLocation();
  const EmpId = state?.EmpId;
  const navigate = useNavigate();

  // ALL useState declarations first
  const [employeeDetails, setEmployeeDetails] = useState([]);
  const [dutyData, setDutyData] = useState([]);
  const [dates, setDates] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loading, setLoading] = useState(false);
  const [shiftData, setShiftData] = useState([]);
  const [shiftLoading, setShiftLoading] = useState(false);
  const [shiftemployeedata, setShiftEmployeeData] = useState([]);
  const [istodate, setistodate] = useState(false);
  const [shiftToDate, setshiftToDate] = useState("");
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [editCategoryModal, setEditCategoryModal] = useState(false);
  const [addCategoryModal, setAddCategoryModal] = useState(false);
  const [Department, setDepartment] = useState([]);
  const [tempShift, SettempShift] = useState([]);
  const [selectedDuty, setSelectedDuty] = useState({
    Id: "",
    EmpId: "",
    ShiftId: "",
    DepartmentId: DepId,
    DateValue: "",
    Remarks: "",
    AddedBy: UID,
    ToDate: "",
    ShiftIdB: "",
  });

  // ALL helper functions
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const generateDateRange = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const dateArray = [];
    let currentDate = new Date(start);
    while (currentDate <= end) {
      dateArray.push(formatDate(new Date(currentDate)));
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return dateArray;
  };

  const getTodayDate = () => {
    return new Date().toISOString().split("T")[0];
  };

  const getDutyForEmployeeAndDate = (employeeId, date) => {
    return dutyData.find(
      (d) =>
        d.EmpId === employeeId && formatDate(new Date(d.DateValue)) === date,
    );
  };

  // ALL data fetching functions
  const getEmployeeData = async () => {
    try {
      const response = await getEmployee(UID);
      if (response?.data?.data) {
        let filterd =
          isAdmin == 1
            ? response?.data?.data
            : response?.data?.data.filter((el) => el.DepartmentId == DepId);
        if (EmpId) {
          filterd = response?.data?.data.filter((el) => el.Id == EmpId);
        }
        setEmployeeDetails(filterd);
        setFilteredEmployees(filterd);
        setShiftEmployeeData(filterd);
      } else {
        toast.error("Employee data is empty or undefined.");
      }
    } catch (error) {
      toast.error("Error fetching employee details.");
    }
  };
  const fetchShiftData = async () => {
    setShiftLoading(true);
    try {
      const response = await getShift(UID);

      if (response?.data?.data) {
        SettempShift(response.data.data);
      } else {
        SettempShift([]);
      }
    } catch (error) {
      toast.error("Error fetching shift data.");
      SettempShift([]);
    } finally {
      setShiftLoading(false);
    }
  };

  const fetchDuties = async () => {
    setLoading(true);
    const data = {
      Date: fromDate,
      ToDate: toDate,
      UserId: UID,
    };
    try {
      const response = await getdutywithdate(data);
      let details = response?.data?.data || [];
      if (isAdmin != 1) {
        details = details.filter((el) => el?.DepartmentID === DepId);
      }
      setDutyData(details);
      setDates(generateDateRange(fromDate, toDate));
    } catch (error) {
      toast.error("Error fetching duty data.");
    } finally {
      setLoading(false);
    }
  };

  const fetchDepartments = async () => {
    try {
      const responses = await getDepartments(UID);
      setDepartment(responses.data.data);
    } catch (error) {
      toast.error("Error fetching departments.");
    }
  };

  // ALL event handlers
  const handleShowClick = () => {
    fetchDuties();
  };

  // Modified handleCellClick function
  const handleCellClick = async (employee, date) => {
    const duty = getDutyForEmployeeAndDate(employee.Id, date);
    if (duty?.DayStatus === 1 && !duty?.ShiftName) {
      toast.error(
        "This day already has an approved leave. Please unapprove it before assigning a shift.",
      );
      return;
    }
    const today = new Date();
    const yesterday = new Date();
    yesterday.setDate(today.getDate() - 3);
    const format = (d) => d.toISOString().split("T")[0];
    if (isAdmin != 1 && date < format(yesterday)) {
      toast.error("Only admins can edit records older than 3 days");
      return;
    }

    const DepartmentIdName = employeeDetails.find(
      (el) => el.Id == employee.Id,
    )?.DepartmentId;

    const DepartmentName = employeeDetails.find(
      (el) => el.Id == employee.Id,
    )?.DepartmentName;

    // Store department ID in localStorage when clicking a date
    setSecureItem("selectedDepartmentId", DepartmentIdName);

    // ✅ Get shifts directly by DepartmentId
    let matchWithShift = tempShift.filter((el) =>
      el.DepartmentId?.split(",")
        .map((d) => d.trim())
        .includes(DepartmentIdName),
    );

    // ✅ Remove duplicates (by Id)
    let uniqueShifts = Array.from(
      new Map(matchWithShift.map((s) => [s.Id, s])).values(),
    );

    let finalShiftData = uniqueShifts;

    // ✅ Merge holiday shifts if department name includes "iti"
    if (DepartmentName?.toLowerCase().includes("iti")) {
      const holidayShifts = tempShift.filter(
        (el) =>
          el.Name?.toLowerCase().includes("holiday") ||
          el.Name?.toLowerCase().includes("other"),
      );

      holidayShifts.forEach((shift) => {
        if (!finalShiftData.find((el) => el.Id === shift.Id)) {
          finalShiftData.push(shift);
        }
      });
    }

    setShiftData(finalShiftData);

    // ✅ Update selectedDuty
    if (duty) {
      setSelectedDuty({
        Id: duty.Id,
        EmpId: duty.EmpId,
        ShiftId: duty.ShiftId,
        DepartmentId: duty.DepartmentID || DepartmentIdName || DepId,
        DateValue: formatDate(new Date(duty.DateValue)),
        Remarks: duty.Remarks || "",
        AddedBy: UID,
        ToDate: duty.ToDate ? formatDate(new Date(duty.ToDate)) : "",
        ShiftIdB: duty.ShiftBId,
      });
    } else {
      setSelectedDuty({
        Id: "",
        EmpId: employee.Id,
        ShiftId: "",
        DepartmentId: DepartmentIdName || DepId,
        DateValue: date,
        Remarks: "",
        AddedBy: UID,
        ToDate: "",
        ShiftIdB: "",
      });
    }

    // ✅ Open the correct modal
    if (duty) {
      openEditCategoryModal();
    } else {
      openAddCategoryModal();
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const DepartmentIdName = employeeDetails.find(
      (el) => el.Id == value,
    )?.DepartmentId;
    if (name === "EmpId") {
      setSelectedDuty((prev) => ({
        ...prev,
        [name]: value,
        DepartmentId: DepartmentIdName || prev.DepartmentId,
      }));
    } else {
      setSelectedDuty((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      istodate &&
      shiftToDate &&
      selectedDuty.DateValue &&
      new Date(shiftToDate) < new Date(selectedDuty.DateValue)
    ) {
      toast.error("To Date cannot be earlier than Assigned Date.");
      return;
    }
    setLoading(true);
    try {
      const empIdArray = Array.isArray(selectedDuty.EmpId)
        ? selectedDuty.EmpId
        : [selectedDuty.EmpId];
      const updatedDutyData = {
        ...selectedDuty,
        EmpId: empIdArray,
        UserId: UID,
        ToDate: istodate ? shiftToDate : selectedDuty?.DateValue,
      };
      const response = await InsertDuty(updatedDutyData);
      console.log(response, "dsddddds");

      if (response) {
        toast.success(response?.data?.message || "Inserted successfully");
        // if (response?.data?.skippedMessages) {
        //   toast.success(response?.data?.skippedMessages);
        // }
        fetchDuties();
        clearData();
        openAddCategoryModal();
        setshiftToDate("");
        setistodate(false);
      } else {
        toast.error(response?.data?.error || "Failed to add duty");
      }
    } catch (error) {
      toast.error(error?.response?.data?.error || "An error occurred");
    } finally {
      setshiftToDate("");
      setistodate(false);
      clearData();
      setLoading(false);
    }
  };

  const handleEdit = async (e) => {
    e.preventDefault();
    if (
      shiftToDate &&
      selectedDuty.DateValue &&
      new Date(shiftToDate) < new Date(selectedDuty.DateValue)
    ) {
      toast.error("To Date cannot be earlier than Assigned Date.");
      return;
    }
    setLoading(true);
    try {
      const empIdArray = Array.isArray(selectedDuty.EmpId)
        ? selectedDuty.EmpId
        : [selectedDuty.EmpId];
      const data = {
        ...selectedDuty,
        EmpId: empIdArray,
        UserId: UID,
        ToDate: shiftToDate || selectedDuty.ToDate,
      };
      const response = await InsertDuty(data);
      console.log(response, "dsdsdssa");

      if (response) {
        toast.success(response?.data?.message || "Updated successfully");
        // if (response?.data?.skippedMessages) {
        //   toast.success(response?.data?.skippedMessages);
        // }
        fetchDuties();
        clearData();
        openEditCategoryModal();
        setshiftToDate("");
      } else {
        toast.error("Failed to update duty");
      }
    } catch (error) {
      toast.error(error?.response?.data?.error || "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  // Modal handlers
  const openEditCategoryModal = () => {
    setEditCategoryModal((prev) => !prev);
    setshiftToDate(selectedDuty.ToDate || "");
  };

  const clearData = () => {
    setSelectedDuty({
      ...selectedDuty,
      Id: "",
      ShiftId: "",
      DateValue: getTodayDate(),
      Remarks: "",
      AddedBy: UID,
      ToDate: "",
      ShiftIdB: "",
    });
    setshiftToDate("");
    setistodate(false);
  };

  const openAddCategoryModal = () => {
    setAddCategoryModal((prev) => !prev);
    setshiftToDate("");
    setistodate(false);
    clearData();
  };

  // ALL useEffect hooks
  // Initialize dates on component mount
  useEffect(() => {
    const today = new Date();
    const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    setFromDate(formatDate(startOfMonth));
    setToDate(formatDate(endOfMonth));
  }, []);

  // Fetch initial data
  useEffect(() => {
    getEmployeeData();
    fetchDepartments();
  }, [UID]);

  // Fetch duties when dates change
  useEffect(() => {
    if (fromDate && toDate) {
      fetchDuties();
    }
  }, [fromDate, toDate]);

  // Filter employees based on search term
  useEffect(() => {
    if (!searchTerm.trim()) {
      setFilteredEmployees(employeeDetails);
    } else {
      const filtered = employeeDetails.filter((employee) => {
        const searchLower = searchTerm.toLowerCase();
        const employeeName = employee.Name?.toLowerCase() || "";
        const employeeCode = employee.Code?.toLowerCase() || "";

        // Check if employee matches Name or Code
        let matches =
          employeeName.includes(searchLower) ||
          employeeCode.includes(searchLower);

        // Also search by shift name from duty data
        const employeeDuties = dutyData.filter(
          (duty) => duty.EmpId === employee.Id,
        );
        const shiftNames = employeeDuties
          .map((duty) => duty.ShiftName?.toLowerCase() || "")
          .join(" ");
        if (shiftNames.includes(searchLower)) {
          matches = true;
        }

        return matches;
      });
      setFilteredEmployees(filtered);
    }
  }, [searchTerm, employeeDetails, dutyData]);

  // Fetch shift data when department changes or after employee filtering
  useEffect(() => {
    if (
      selectedDuty.DepartmentId &&
      (employeeDetails.length > 0 || filteredEmployees.length > 0)
    ) {
      fetchShiftData();
    }
  }, [selectedDuty.DepartmentId, employeeDetails, filteredEmployees]);

  // Fetch shift data when modal opens
  useEffect(() => {
    if ((editCategoryModal || addCategoryModal) && selectedDuty.DepartmentId) {
      fetchShiftData();
    }
  }, [editCategoryModal, addCategoryModal, selectedDuty.DepartmentId]);

  return (
    <div className="container mx-auto p-4">
      <div className="flex items-center justify-between w-full mb-4">
        <div className="flex items-center gap-4">
          <Breadcrumb title="Duty Allocation Muster" />
          {EmpId && (
            <button
              onClick={() => navigate("/duty", { state: { EmpId } })}
              className="bg-gray-200 text-gray-700 px-4 py-2 rounded hover:bg-gray-300 transition"
            >
              ← Back
            </button>
          )}
        </div>
      </div>

      <div className="flex items-center justify-between w-full">
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2">
            <label htmlFor="fromDate">From:</label>
            <input
              type="date"
              id="fromDate"
              className="border px-2 py-1 rounded"
              value={fromDate}
              onChange={(e) => setFromDate(e.target.value)}
            />
          </div>
          <div className="flex items-center gap-2">
            <label htmlFor="toDate">To:</label>
            <input
              type="date"
              id="toDate"
              className="border px-2 py-1 rounded"
              value={toDate}
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>
          <button className="btn btn-success" onClick={handleShowClick}>
            Show
          </button>
        </div>
        <div className="flex items-center gap-2">
          <label htmlFor="searchInput">Search:</label>
          <input
            type="text"
            id="searchInput"
            placeholder="Name, Code or Shift..."
            className="border px-4 py-2 rounded w-full w-[400px]"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      </div>

      {loading && !editCategoryModal && !addCategoryModal ? (
        <div className="text-center py-4">Loading...</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full border border-gray-300">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-gray-300 px-4 py-2 sticky left-0 bg-gray-100 z-5">
                  Employee
                </th>
                {dates.map((date, index) => (
                  <th
                    key={index}
                    className="border border-gray-300 px-4 py-2 text-center"
                  >
                    {new Date(date).toLocaleDateString("en-US", {
                      month: "short",
                      day: "numeric",
                    })}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filteredEmployees.map((employee) => (
                <tr key={employee.Id}>
                  <td className="border border-gray-300 px-4 py-2 sticky left-0 bg-white z-5 font-medium">
                    {employee.Name} ({employee.Code})
                  </td>
                  {dates.map((date, index) => {
                    const duty = getDutyForEmployeeAndDate(employee.Id, date);
                    return (
                      <td
                        key={index}
                        className={`border border-gray-300 px-4 py-2 text-center cursor-pointer ${
                          duty?.DayStatus === 1 ? "bg-green-100 " : ""
                        }`}
                        onClick={() => handleCellClick(employee, date)}
                      >
                        {duty
                          ? duty.ShiftName || duty.ShiftBName
                            ? `${duty.ShiftName || ""}${duty.ShiftBName ? " / " + duty.ShiftBName : ""}`
                            : "L/W"
                          : "-"}{" "}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {filteredEmployees.length === 0 && !loading && (
        <div className="text-center py-4">No employee data available.</div>
      )}

      {filteredEmployees.length > 0 && dutyData.length === 0 && !loading && (
        <div className="text-center py-4">
          No duty allocations found for the selected date range.
        </div>
      )}

      {editCategoryModal && (
        <>
          <div className="fixed p-15 w-full max-w-[750px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
            <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">
              <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                Edit Duty
                <span className="absolute top-0 right-0">
                  <button
                    onClick={openEditCategoryModal}
                    className="btn flex items-center justify-center"
                  >
                    ✖
                  </button>
                </span>
              </h5>
              <form onSubmit={handleEdit} className="my-10 md:px-10 px-[7px]">
                <div className="my-10 md:px-10 px-[7px] max-h-[75vh] overflow-auto cus-scrollbar-point-bottom">
                  <div className="grid grid-cols-12 gap-20">
                    <div className="form-group flex col-span-12"></div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>
                        Assigned Date <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="date"
                        id="date"
                        disabled
                        required
                        name="DateValue"
                        placeholder="date"
                        value={selectedDuty.DateValue}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>
                        Shift A <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        name="ShiftId"
                        value={selectedDuty.ShiftId || ""}
                        onChange={handleChange}
                        required
                        disabled={shiftLoading}
                      >
                        <option value="">Select</option>
                        {shiftLoading ? (
                          <option value="" disabled>
                            Loading shifts...
                          </option>
                        ) : shiftData.length > 0 ? (
                          shiftData.map((shift) => (
                            <option key={shift.Id} value={shift.Id}>
                              {shift.Name}
                            </option>
                          ))
                        ) : (
                          <option value="" disabled>
                            No shifts available
                          </option>
                        )}
                      </select>
                    </div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>Shift B</label>
                      <select
                        name="ShiftIdB"
                        value={selectedDuty.ShiftIdB || ""}
                        onChange={handleChange}
                        disabled={shiftLoading}
                      >
                        <option value="">Select</option>
                        {shiftLoading ? (
                          <option value="" disabled>
                            Loading shifts...
                          </option>
                        ) : shiftData.length > 0 ? (
                          shiftData.map((shift) => (
                            <option key={shift.Id} value={shift.Id}>
                              {shift.Name}
                            </option>
                          ))
                        ) : (
                          <option value="" disabled>
                            No shifts available
                          </option>
                        )}
                      </select>
                    </div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>
                        Employee <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        name="EmpId"
                        value={selectedDuty.EmpId || ""}
                        onChange={handleChange}
                        required
                        disabled
                      >
                        <option value="">---select one---</option>
                        {shiftemployeedata.map((data) => (
                          <option key={data.Id} value={data.Id}>
                            {data.Name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>
                        Department <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        name="DepartmentId"
                        value={selectedDuty.DepartmentId || ""}
                        onChange={handleChange}
                        required
                        disabled
                      >
                        <option value="">Select</option>
                        {Department.map((shift) => (
                          <option key={shift.Id} value={shift.Id}>
                            {shift.Name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>Remarks</label>
                      <input
                        type="text"
                        id="remarks"
                        name="Remarks"
                        placeholder="Remarks"
                        value={selectedDuty.Remarks}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>
                        To Date <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="date"
                        id="shiftToDate"
                        required
                        className="border px-2 py-1 rounded"
                        value={shiftToDate}
                        onChange={(e) => {
                          setshiftToDate(e.target.value);
                          setSelectedDuty((prev) => ({
                            ...prev,
                            ToDate: e.target.value,
                          }));
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                  <button
                    type="button"
                    onClick={clearData}
                    className="btn btn-outline-secondary"
                  >
                    Clear
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "Update"}
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"></div>
        </>
      )}

      {addCategoryModal && (
        <>
          <div className="fixed p-15 w-full max-w-[750px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
            <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">
              <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                Add Duty
                <span className="absolute top-0 right-0">
                  <button
                    onClick={openAddCategoryModal}
                    className="btn flex items-center justify-center"
                  >
                    ✖
                  </button>
                </span>
              </h5>
              <form onSubmit={handleSubmit} className="my-10 md:px-10 px-[7px]">
                <div className="my-10 md:px-10 px-[7px] max-h-[75vh] overflow-auto cus-scrollbar-point-bottom">
                  <div className="grid grid-cols-12 gap-20">
                    <div className="form-group flex col-span-12"></div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>
                        Assigned Date <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="date"
                        id="date"
                        required
                        disabled
                        name="DateValue"
                        placeholder="date"
                        value={selectedDuty.DateValue}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>
                        Shift Name <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        name="ShiftId"
                        value={selectedDuty.ShiftId || ""}
                        onChange={handleChange}
                        required
                        disabled={shiftLoading}
                      >
                        <option value="">Select</option>
                        {shiftLoading ? (
                          <option value="" disabled>
                            Loading shifts...
                          </option>
                        ) : shiftData.length > 0 ? (
                          shiftData.map((shift) => (
                            <option key={shift.Id} value={shift.Id}>
                              {shift.Name}
                            </option>
                          ))
                        ) : (
                          <option value="" disabled>
                            No shifts available
                          </option>
                        )}
                      </select>
                    </div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>
                        Employee <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        name="EmpId"
                        value={selectedDuty.EmpId || ""}
                        onChange={handleChange}
                        required
                        disabled
                      >
                        <option value="">---select one---</option>
                        {shiftemployeedata.map((data) => (
                          <option key={data.Id} value={data.Id}>
                            {data.Name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>
                        Department <span style={{ color: "red" }}>*</span>
                      </label>
                      <select
                        name="DepartmentId"
                        value={selectedDuty.DepartmentId || ""}
                        onChange={handleChange}
                        required
                        disabled
                      >
                        <option value="">Select</option>
                        {Department.map((shift) => (
                          <option key={shift.Id} value={shift.Id}>
                            {shift.Name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>Remarks</label>
                      <input
                        type="text"
                        id="remarks"
                        name="Remarks"
                        placeholder="Remarks"
                        value={selectedDuty.Remarks}
                        onChange={handleChange}
                      />
                    </div>
                    {istodate && (
                      <div className="form-group flex col-span-12 flex-col">
                        <label>To Date</label>
                        <input
                          type="date"
                          id="shiftToDate"
                          className="border px-2 py-1 rounded"
                          value={shiftToDate}
                          onChange={(e) => setshiftToDate(e.target.value)}
                        />
                      </div>
                    )}
                  </div>
                </div>
                <div>
                  {!istodate && (
                    <button
                      type="button"
                      onClick={() => setistodate(true)}
                      className="btn btn-primary"
                    >
                      Add for Long time
                    </button>
                  )}
                </div>
                <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                  <button
                    type="button"
                    onClick={clearData}
                    className="btn btn-outline-secondary"
                  >
                    Clear
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "Add"}
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"></div>
        </>
      )}
    </div>
  );
}

export default DutyAllocationMuster;
